import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="header">
      <nav className="nav nav--tours">
        <Link to="/" className="nav__el" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <img src="/img/AeLogo.ico" alt="Aethermap Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '15%' }} />
          <span style={{ fontWeight: 700, fontSize: '1.2rem' }}>Aethermap</span>
        </Link>
      </nav>
      <nav className="nav nav--user">
        {isAuthenticated ? (
          <>
            <Link to="/" className="nav__el">
              Overview
            </Link>
            <Link to="/characters" className="nav__el">
              Characters
            </Link>
            <Link to="/elements" className="nav__el">
              Elements
            </Link>
            <Link to="/pillars" className="nav__el">
              Pillars
            </Link>
            <div className="nav__el">
              <span className="nav__user-name">Hello, {user?.name}</span>
            </div>
            <button onClick={handleLogout} className="nav__el nav__el--logout">
              Logout
            </button>
          </>
        ) : (
          <Link to="/login" className="nav__el nav__el--login">
            Log in
          </Link>
        )}
      </nav>
    </header>
  );
};

export default Header; 